<template>
  <div class="help-center-content">
    <div class="help-center-content-row">
      <span @click="goHelpCenter" class="help-center-cont">
        <i class="el-icon-arrow-left"></i>
        <span class="help-center-title">{{ $t('帮助中心') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpCenterHeader',
  props: {
    params: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goHelpCenter() {
      this.$router.push({
        path: '/user/help/',
        query: Object.assign(this.$route.query, this.params),
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
